module.exports = __webpack_public_path__ + "static/img/Kalyn-Ponga.2a03199.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Kalyn-Ponga.jpg
// module id = j0DA
// module chunks = 0